module.exports = __webpack_public_path__ + "static/media/catimage.73b4a3b9.jpg";